var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.794 23.51h-11.02L23.51 40.773v11.02l17.263 17.264h11.02l17.264-17.263v-11.02L51.793 23.51Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.456 42.56v-6.828l-.31-.31h-3.724l-.31.31v6.828l.62 7.137.31.31h2.483l.31-.31.62-7.137Zm.31 14.275V52.8l-.31-.31H44.11l-.31.31v4.035l.31.31h4.345l.31-.31Z",
    fill: "currentColor"
  })));
};
export default SvgStop;